<div class="empty-container">
  <mat-icon class="empty-icon" svgIcon="search"></mat-icon>
  <h4 class="empty-title">{{ title }}</h4>
  <p class="empty-description">{{ description }}</p>

  <button
    *ngIf="showSuggestion"
    (click)="onSuggestionClick()"
    class="btn-suggestion"
  >
    {{ 'RESTAURANTS.MAKE_SUGGESTION' | translate }}
  </button>
</div>
